import {User} from '@/models/User';
import { BehaviorSubject } from 'rxjs';
import axios, {AxiosRequestConfig} from 'axios';
import {Role} from '@/_helpers/role';

// tslint:disable-next-line:max-line-length
const currentUserSubject: BehaviorSubject<User|null> = new BehaviorSubject(JSON.parse(localStorage.getItem('user') as string));

const userService = {
    login,
    logout,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value;
    },
};

export default userService;

const config = {
    baseURL: process.env.VUE_APP_BASE_URL || '',
    timeout: 60 * 1000,
    withCredentials: true,
};

const axiosClient = axios.create(config);

async function login(username: string, password: string) {
    const requestOptions: AxiosRequestConfig = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const data = JSON.stringify({username, password});

    const { data: user } = await axiosClient.post<User>('/api/users/authenticate', data, requestOptions);
    if (user) {
        const now = new Date();
        now.addDays(5);
        user.role = Role.User;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('expire', now.getTime().toString());
        currentUserSubject.next(user);
    }
}

async function logout() {
    // remove user from local storage to log user out
    await new Promise((resolve) => {
        setTimeout(resolve, 1000);
    });
    localStorage.removeItem('user');
    localStorage.removeItem('expire');
    currentUserSubject.next(null);
}

async function handleResponse(response: Response): Promise<User> {
    return await response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return new User(data.id, data.firstName, data.lastName, data.username, data.token);
    });
}
